import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { css } from 'aphrodite';
import { FC, ReactNode, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { DashboardCard, DashboardCardHeaderLabel } from '../DashboardCard';
import { AgentRowSkeleton } from './AgentRow';
import { DashboardEmailExecErrorRow } from './rows/EmailExec/DashboardEmailExecErrorRow';
import { DashboardEmailExecRow, useEmailExecRowVisibility } from './rows/EmailExec/DashboardEmailExecRow';
import { styleSheet } from './styles';

export const DashboardAgentsCard: FC = () => {
	const emailExec = useEmailExecRowVisibility();

	if (!emailExec.visible) {
		return null;
	}

	return (
		<DashboardCard styleDeclaration={styleSheet.card}>
			<div className={css(styleSheet.cardHeader)}>
				<DashboardCardHeaderLabel styleDeclaration={styleSheet.headerContent}>
					<span className={css(styleSheet.statusDot)} />
					<span>Your agents are working</span>
				</DashboardCardHeaderLabel>
			</div>
			<div className={css(styleSheet.rows)}>
				<AgentRowBoundary renderError={reset => <DashboardEmailExecErrorRow onRetry={reset} />}>
					<DashboardEmailExecRow />
				</AgentRowBoundary>
			</div>
		</DashboardCard>
	);
};

const AgentRowBoundary: FC<{
	children: ReactNode;
	renderError: (reset: () => void) => ReactNode;
}> = ({ children, renderError }) => (
	<QueryErrorResetBoundary>
		{({ reset }) => (
			<ErrorBoundary
				onReset={reset}
				fallbackRender={({ resetErrorBoundary }) => <>{renderError(() => resetErrorBoundary())}</>}
			>
				<Suspense fallback={<AgentRowSkeleton />}>{children}</Suspense>
			</ErrorBoundary>
		)}
	</QueryErrorResetBoundary>
);
